import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './Workflow_Instance.css';

const Workflow_Instance = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"WORKFLOW_INSTANCE",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	WORKFLOW_INSTANCE:-1
  });


  const [WORKFLOW_INSTANCE, setWORKFLOW_INSTANCE] = React.useState(null);
  const [WORKFLOW_INSTANCE_D, setWORKFLOW_INSTANCE_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Workflow Instance');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/Workflow_Instance',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewWORKFLOW_INSTANCE(clientInfo,"OpenNew");

		navigate('/Workflow_Instance',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Workflow_Instance_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(WORKFLOW_INSTANCE));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutWORKFLOW_INSTANCE(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostWORKFLOW_INSTANCE(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewWORKFLOW_INSTANCE(clientInfo,"OpenNew");
		}
		navigate('/Workflow_Instance',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Workflow_Instance_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Workflow_Instance_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Workflow_Instance_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(WORKFLOW_INSTANCE));
		if(Temp_Data2.status!="New"){
			handleDeleteWORKFLOW_INSTANCE(Temp_Data2);
			navigate('/Workflow_Instance#New',{replace:true});
		} 
		else 
			navigate('/Workflow_Instance',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Workflow_Instance',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Workflow_Instance',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Workflow_Instance',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Workflow_Instance',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!WORKFLOW_INSTANCE) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_${i}_SECTION`;
	  const headerId = `#PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [WORKFLOW_INSTANCE]) ;


  
  
  var Ids = [];
  for(var Ele in WORKFLOW_INSTANCE){
	  for(var Sec in WORKFLOW_INSTANCE[Ele]){
		if(Sec == "id")
			Ids.push(WORKFLOW_INSTANCE[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(WORKFLOW_INSTANCE[Ele]["status"]);
		else if(Array.isArray(WORKFLOW_INSTANCE[Ele][Sec]))
			  for(var Row in WORKFLOW_INSTANCE[Ele][Sec])  // Convert to WORKFLOW_INSTANCE[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in WORKFLOW_INSTANCE[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["WORKFLOW_INSTANCE"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewWORKFLOW_INSTANCE(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/WORKFLOW_INSTANCE`).then((response1) => {
		if(!WORKFLOW_INSTANCE) 
			setWORKFLOW_INSTANCE(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/WORKFLOW_INSTANCE_D`).then((response2) => {
			setWORKFLOW_INSTANCE_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddWORKFLOW_INSTANCE_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewWORKFLOW_INSTANCE = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/WORKFLOW_INSTANCE/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setWORKFLOW_INSTANCE(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataWORKFLOW_INSTANCE = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/WORKFLOW_INSTANCE/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutWORKFLOW_INSTANCE = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/WORKFLOW_INSTANCE/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostWORKFLOW_INSTANCE = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/WORKFLOW_INSTANCE', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteWORKFLOW_INSTANCE = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/WORKFLOW_INSTANCE', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_INSTANCE));
	Temp_Data["1"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_0"]=value;
	//handleAddWORKFLOW_INSTANCE(Temp_Data,App_Data['WORKFLOW_INSTANCE']);
	Form_Data_onChange("1","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_0",value,Temp_Data);
 	//handleLastDataWORKFLOW_INSTANCE(Temp_Data);
    setWORKFLOW_INSTANCE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_INSTANCE));
	Temp_Data["1"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_1"]=value;
	//handleAddWORKFLOW_INSTANCE(Temp_Data,App_Data['WORKFLOW_INSTANCE']);
	Form_Data_onChange("1","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_1",value,Temp_Data);
 	//handleLastDataWORKFLOW_INSTANCE(Temp_Data);
    setWORKFLOW_INSTANCE(Temp_Data);
 }; 
  

const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_INSTANCE));
	Temp_Data["1"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_2"]=value;
	Form_Data_onChange("1","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_2",value,Temp_Data);
 	//handleLastDataWORKFLOW_INSTANCE(Temp_Data);
    setWORKFLOW_INSTANCE(Temp_Data);
	//handleAddWORKFLOW_INSTANCE(Temp_Data,App_Data['WORKFLOW_INSTANCE']);
  }; 
  

    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_INSTANCE));
	Temp_Data["1"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_3"]=value;
	//handleAddWORKFLOW_INSTANCE(Temp_Data,App_Data['WORKFLOW_INSTANCE']);
	Form_Data_onChange("1","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_3",value,Temp_Data);
 	//handleLastDataWORKFLOW_INSTANCE(Temp_Data);
    setWORKFLOW_INSTANCE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_INSTANCE));
	Temp_Data["1"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_4"]=value;
	//handleAddWORKFLOW_INSTANCE(Temp_Data,App_Data['WORKFLOW_INSTANCE']);
	Form_Data_onChange("1","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_4",value,Temp_Data);
 	//handleLastDataWORKFLOW_INSTANCE(Temp_Data);
    setWORKFLOW_INSTANCE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_INSTANCE));
	Temp_Data["1"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_5"]=value;
	//handleAddWORKFLOW_INSTANCE(Temp_Data,App_Data['WORKFLOW_INSTANCE']);
	Form_Data_onChange("1","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_5",value,Temp_Data);
 	//handleLastDataWORKFLOW_INSTANCE(Temp_Data);
    setWORKFLOW_INSTANCE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_INSTANCE));
	Temp_Data["2"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_0"]=value;
	//handleAddWORKFLOW_INSTANCE(Temp_Data,App_Data['WORKFLOW_INSTANCE']);
	Form_Data_onChange("2","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_0",value,Temp_Data);
 	//handleLastDataWORKFLOW_INSTANCE(Temp_Data);
    setWORKFLOW_INSTANCE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_INSTANCE));
	Temp_Data["2"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_1"]=value;
	//handleAddWORKFLOW_INSTANCE(Temp_Data,App_Data['WORKFLOW_INSTANCE']);
	Form_Data_onChange("2","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_1",value,Temp_Data);
 	//handleLastDataWORKFLOW_INSTANCE(Temp_Data);
    setWORKFLOW_INSTANCE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_INSTANCE));
	Temp_Data["2"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_2"]=value;
	//handleAddWORKFLOW_INSTANCE(Temp_Data,App_Data['WORKFLOW_INSTANCE']);
	Form_Data_onChange("2","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_2",value,Temp_Data);
 	//handleLastDataWORKFLOW_INSTANCE(Temp_Data);
    setWORKFLOW_INSTANCE(Temp_Data);
 }; 
  

const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_INSTANCE));
	Temp_Data["2"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_3"]=value;
	Form_Data_onChange("2","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_3",value,Temp_Data);
 	//handleLastDataWORKFLOW_INSTANCE(Temp_Data);
    setWORKFLOW_INSTANCE(Temp_Data);
	//handleAddWORKFLOW_INSTANCE(Temp_Data,App_Data['WORKFLOW_INSTANCE']);
  }; 
  

    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_INSTANCE));
	Temp_Data["3"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_0"]=value;
	//handleAddWORKFLOW_INSTANCE(Temp_Data,App_Data['WORKFLOW_INSTANCE']);
	Form_Data_onChange("3","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_0",value,Temp_Data);
 	//handleLastDataWORKFLOW_INSTANCE(Temp_Data);
    setWORKFLOW_INSTANCE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_INSTANCE));
	Temp_Data["3"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_1"]=value;
	//handleAddWORKFLOW_INSTANCE(Temp_Data,App_Data['WORKFLOW_INSTANCE']);
	Form_Data_onChange("3","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_1",value,Temp_Data);
 	//handleLastDataWORKFLOW_INSTANCE(Temp_Data);
    setWORKFLOW_INSTANCE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_INSTANCE));
	Temp_Data["3"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_2"]=value;
	//handleAddWORKFLOW_INSTANCE(Temp_Data,App_Data['WORKFLOW_INSTANCE']);
	Form_Data_onChange("3","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_2",value,Temp_Data);
 	//handleLastDataWORKFLOW_INSTANCE(Temp_Data);
    setWORKFLOW_INSTANCE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_INSTANCE));
	Temp_Data["3"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_3"]=value;
	//handleAddWORKFLOW_INSTANCE(Temp_Data,App_Data['WORKFLOW_INSTANCE']);
	Form_Data_onChange("3","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_3",value,Temp_Data);
 	//handleLastDataWORKFLOW_INSTANCE(Temp_Data);
    setWORKFLOW_INSTANCE(Temp_Data);
 }; 
  
  
      
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_4_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_INSTANCE));
	Temp_Data["4"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_4_0"]=value ? true : false; // optionally just use boolean
	//handleAddWORKFLOW_INSTANCE(Temp_Data,App_Data['WORKFLOW_INSTANCE']);
	Form_Data_onChange("4","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_4_0",value,Temp_Data);
 	//handleLastDataWORKFLOW_INSTANCE(Temp_Data);
    setWORKFLOW_INSTANCE(Temp_Data);
 }; 
  


    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_INSTANCE));
	Temp_Data["4"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_4_1"]=value;
	//handleAddWORKFLOW_INSTANCE(Temp_Data,App_Data['WORKFLOW_INSTANCE']);
	Form_Data_onChange("4","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_4_1",value,Temp_Data);
 	//handleLastDataWORKFLOW_INSTANCE(Temp_Data);
    setWORKFLOW_INSTANCE(Temp_Data);
 }; 
  

const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_INSTANCE));
	Temp_Data["9"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_0"]=value;
	Form_Data_onChange("9","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_0",value,Temp_Data);
 	//handleLastDataWORKFLOW_INSTANCE(Temp_Data);
    setWORKFLOW_INSTANCE(Temp_Data);
	//handleAddWORKFLOW_INSTANCE(Temp_Data,App_Data['WORKFLOW_INSTANCE']);
  }; 
  

    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_INSTANCE));
	Temp_Data["9"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_1"]=value;
	//handleAddWORKFLOW_INSTANCE(Temp_Data,App_Data['WORKFLOW_INSTANCE']);
	Form_Data_onChange("9","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_1",value,Temp_Data);
 	//handleLastDataWORKFLOW_INSTANCE(Temp_Data);
    setWORKFLOW_INSTANCE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_INSTANCE));
	Temp_Data["9"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_2"]=value;
	//handleAddWORKFLOW_INSTANCE(Temp_Data,App_Data['WORKFLOW_INSTANCE']);
	Form_Data_onChange("9","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_2",value,Temp_Data);
 	//handleLastDataWORKFLOW_INSTANCE(Temp_Data);
    setWORKFLOW_INSTANCE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_INSTANCE));
	Temp_Data["9"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_3"]=value;
	//handleAddWORKFLOW_INSTANCE(Temp_Data,App_Data['WORKFLOW_INSTANCE']);
	Form_Data_onChange("9","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_3",value,Temp_Data);
 	//handleLastDataWORKFLOW_INSTANCE(Temp_Data);
    setWORKFLOW_INSTANCE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_INSTANCE));
	Temp_Data["9"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_4"]=value;
	//handleAddWORKFLOW_INSTANCE(Temp_Data,App_Data['WORKFLOW_INSTANCE']);
	Form_Data_onChange("9","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_4",value,Temp_Data);
 	//handleLastDataWORKFLOW_INSTANCE(Temp_Data);
    setWORKFLOW_INSTANCE(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!WORKFLOW_INSTANCE) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedWORKFLOW_INSTANCE =JSON.parse(JSON.stringify(WORKFLOW_INSTANCE));
  updatedWORKFLOW_INSTANCE[Sec] = [...updatedWORKFLOW_INSTANCE[Sec], newRow];
  setWORKFLOW_INSTANCE(updatedWORKFLOW_INSTANCE);
};

const handleDeleteRow = (sec,index) => {
  const updatedWORKFLOW_INSTANCE = JSON.parse(JSON.stringify(WORKFLOW_INSTANCE));
  updatedWORKFLOW_INSTANCE[sec].splice(index, 1);
  setWORKFLOW_INSTANCE(updatedWORKFLOW_INSTANCE);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Workflow Instance`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Workflow Instance ID`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Workflow Instance ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_0" type="text" className="form-control" placeholder="Workflow Instance ID" value={WORKFLOW_INSTANCE["1"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_0`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Workflow Instance ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Workflow ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_1" type="text" className="form-control" placeholder="Workflow ID" value={WORKFLOW_INSTANCE["1"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_1`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Workflow ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Token Type Code`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_2"  value={WORKFLOW_INSTANCE["1"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_2`]} onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_2_Change} className="form-control" name="Token Type Code"  >
						  <option value="RENT_INCOME_TOKEN">RENT_INCOME_TOKEN</option>
						  <option value="REVENUE_SHARE_TOKEN">REVENUE_SHARE_TOKEN</option>
						  <option value="SALE_PROFIT_TOKEN">SALE_PROFIT_TOKEN</option>
						  <option value="EQUITY_APPRECIATION_TOKEN">EQUITY_APPRECIATION_TOKEN</option>
						  <option value="PREFERRED_EQUITY_TOKEN">PREFERRED_EQUITY_TOKEN</option>
						  <option value="COMMON_EQUITY_TOKEN">COMMON_EQUITY_TOKEN</option>
						  <option value="DEBT_NOTE_TOKEN">DEBT_NOTE_TOKEN</option>
						  <option value="HYBRID_TOKEN">HYBRID_TOKEN</option>
						  <option value="PRE_AUCTION_POOL_TOKEN">PRE_AUCTION_POOL_TOKEN</option>
						  <option value="POST_AUCTION_TOKENIZATION">POST_AUCTION_TOKENIZATION</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Token Type Code
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_3" type="text" className="form-control" placeholder="Asset ID" value={WORKFLOW_INSTANCE["1"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_3`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_4" type="text" className="form-control" placeholder="Offering ID" value={WORKFLOW_INSTANCE["1"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_4`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`SPV ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_5" type="text" className="form-control" placeholder="SPV ID" value={WORKFLOW_INSTANCE["1"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_5`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_5_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_1_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter SPV ID`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Current Step ID`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Current Step ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_0" type="text" className="form-control" placeholder="Current Step ID" value={WORKFLOW_INSTANCE["2"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_0`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Current Step ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '120ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Current Step Name`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_1" type="text" className="form-control" placeholder="Current Step Name" value={WORKFLOW_INSTANCE["2"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_1`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '120ch' }}>
						 {t(`Enter Current Step Name`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Current Assignee User ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_2" type="text" className="form-control" placeholder="Current Assignee User ID" value={WORKFLOW_INSTANCE["2"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_2`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Current Assignee User ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Workflow Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_3"  value={WORKFLOW_INSTANCE["2"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_3`]} onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_2_3_Change} className="form-control" name="Workflow Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="In Progress">In Progress</option>
						  <option value="Waiting for Stakeholder">Waiting for Stakeholder</option>
						  <option value="Waiting for Approval">Waiting for Approval</option>
						  <option value="Blocked">Blocked</option>
						  <option value="Completed">Completed</option>
						  <option value="Cancelled">Cancelled</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Workflow Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Started At`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Started At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_0" type="text" className="form-control" placeholder="Started At" value={WORKFLOW_INSTANCE["3"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_0`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Started At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Due At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_1" type="text" className="form-control" placeholder="Due At" value={WORKFLOW_INSTANCE["3"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_1`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Due At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Completed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_2" type="text" className="form-control" placeholder="Completed At" value={WORKFLOW_INSTANCE["3"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_2`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Completed At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '50ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Delay Days`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_3" type="text" className="form-control" placeholder="Delay Days" value={WORKFLOW_INSTANCE["3"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_3`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_3_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '50ch' }}>
						 {t(`Enter Delay Days`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Exception Flag`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_4_SECTION" className="row">
			                 {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_4_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Exception Flag`)} <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_4_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_4_0_Change} 
					  checked={WORKFLOW_INSTANCE?.["4"]?.["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_4_0"] === "true" || WORKFLOW_INSTANCE?.["4"]?.["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_4_0"] === true} />
					</label>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '2000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Exception Reason`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_4_1" type="text" className="form-control" placeholder="Exception Reason" value={WORKFLOW_INSTANCE["4"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_4_1`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_4_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_4_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '2000ch' }}>
						 {t(`Enter Exception Reason`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_0"  value={WORKFLOW_INSTANCE["9"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_0`]} onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_1" type="text" className="form-control" placeholder="Created By" value={WORKFLOW_INSTANCE["9"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_1`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_2" type="text" className="form-control" placeholder="Created At" value={WORKFLOW_INSTANCE["9"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_2`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_3" type="text" className="form-control" placeholder="Updated By" value={WORKFLOW_INSTANCE["9"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_3`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_4" type="text" className="form-control" placeholder="Updated At" value={WORKFLOW_INSTANCE["9"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_4`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_WORKFLOW_INSTANCE_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default Workflow_Instance;  